export function isLocalCarrierOrder(order) {
  const po = String(order?.po_number || "");
  if (/LC$/i.test(po)) return true;
  if (order?.is_local_carrier === true || order?.is_local_carrier === 1 || order?.is_local_carrier === "1") {
    return true;
  }
  const carrier = String(order?.carrier || "").toUpperCase();
  if (carrier === "NASH" || carrier === "CURRI" || carrier.includes("LOCAL") || carrier === "ROADIE") {
    return true;
  }
  const type = String(order?.order_type || "").toLowerCase();
  if (type.includes("nash") || type.includes("curri") || type.includes("local carrier")) return true;
  return false;
}
